"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEAVE_GROUP_FAILED = exports.LEAVE_GROUP_SUCCEEDED = exports.LEAVE_GROUP_REQUESTED = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
const leaveGroup_1 = require("../../services/chats/leaveGroup");
const modalSpinner_1 = require("../app/modalSpinner");
exports.LEAVE_GROUP_REQUESTED = "LEAVE_GROUP_REQUESTED";
exports.LEAVE_GROUP_SUCCEEDED = "LEAVE_GROUP_SUCCEEDED";
exports.LEAVE_GROUP_FAILED = "LEAVE_GROUP_FAILED";
function default_1(chatId) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        dispatch(modalSpinner_1.startSpinning());
        const requestEvent = {
            type: exports.LEAVE_GROUP_REQUESTED,
            payload: {
                chatId
            }
        };
        dispatch(requestEvent);
        const result = yield service_1.default.leaveGroup(chatId);
        if (result === leaveGroup_1.LeaveGroupResult.Success) {
            dispatch({
                type: exports.LEAVE_GROUP_SUCCEEDED,
                payload: {
                    chatId
                }
            });
        }
        else {
            dispatch({
                type: exports.LEAVE_GROUP_FAILED,
                payload: {
                    chatId,
                    result
                }
            });
        }
        dispatch(modalSpinner_1.stopSpinning());
    });
}
exports.default = default_1;
